/**
 * native-modal.js
 * Minimal controller for native <dialog> popups used across the theme.
 *
 * Wiring contract:
 *   - Trigger: any element with [data-open-modal="<dialog-id>"]
 *   - Close button inside dialog: any element with [data-close-modal]
 *   - Backdrop click on dialog.native-modal also closes
 *
 * Idempotent: every element processed is marked with [data-modal-bound]
 * so running this module more than once (or alongside a legacy inline
 * binding) does not double-register listeners.
 *
 * Handles Shopify section:load / section:reorder editor events so
 * newly-injected sections in the theme editor get wired up live.
 */
(function () {
  function bind() {
    document.querySelectorAll('[data-open-modal]:not([data-modal-bound])').forEach(function (btn) {
      btn.setAttribute('data-modal-bound', '1');
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.dataset.openModal);
        if (d && typeof d.showModal === 'function') d.showModal();
      });
    });
    document.querySelectorAll('[data-close-modal]:not([data-modal-bound])').forEach(function (btn) {
      btn.setAttribute('data-modal-bound', '1');
      btn.addEventListener('click', function (e) {
        var d = e.target.closest('dialog');
        if (d) d.close();
      });
    });
    document.querySelectorAll('dialog.native-modal:not([data-modal-bound])').forEach(function (d) {
      d.setAttribute('data-modal-bound', '1');
      d.addEventListener('click', function (e) {
        if (e.target === d) d.close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  // Shopify theme-editor hooks — re-bind when sections are re-rendered.
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:reorder', bind);
})();
